const userProfileReducer = (state = {}, action) => {

  switch (action.type) {

    case "userProfileResponse": {

      return {
        ...action.userProfile
      }

    }
    default:
      return state;
  }

}

export default userProfileReducer;


// WEBPACK FOOTER //
// ./src/Components/UserProfile/reducer/index.js